import { useQuery } from "@apollo/client";
import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { orderBy } from "lodash";
import { Dropdown } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCampaignsName } from "../../../graphql/queries/getCampaignListing";
import { getTranslatedText } from "../../../utils/commons";

const CampaignNameSelectComponent = (props) => {
  const { t } = useTranslation();
  const { handleChange, label, path, required, visible, enabled, data, uischema } =
    props;

  const [campaignOptions, setCampaignOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [hasLoadedData, setHasLoadedData] = useState(false);
  const { data: campaignsData } = useQuery(getCampaignsName, {
    variables: {
      filter: {
        //campaignStatus: "ACTIVE",
      },
    },
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    if (campaignsData) {
      const sortedCampaigns = orderBy(
        campaignsData.listCampaigns,
        ["title"],
        ["asc"]
      );
      setCampaignOptions(sortedCampaigns);
      if (data?.length && !hasLoadedData) {
        const formattedData = uischema.returnStringFormat
          ? data.split(",").map((item) => item.trim())
          : data;
        setSelected(
          formatOptions(
            formattedData.map(
              (item) => sortedCampaigns.find((option) => option.id === item) || {}
            )
          )
        );
        setHasLoadedData(true);
      }
    }
  }, [campaignsData, data, hasLoadedData, uischema?.returnStringFormat]);

  const formatOptions = (options) =>
    options.map((option) => ({
      id: option.id,
      displayText: option.title,
    }));
  const formatData = (data) => (data ? data.map((item) => item.id) : []);

  const handleSelectValue = (val) => {
    setSelected(val);
    const formatedData = uischema.returnStringFormat
      ? formatData(val).join(",")
      : formatData(val);
    handleChange(path, formatedData);
  };

  return visible ? (
    <div className="multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        childList={formatOptions(campaignOptions)}
        selection={uischema.selection || "multiple"}
        isRequired={required}
        label={getTranslatedText(t, label, label)}
        disabled={!enabled}
        selectedValue={selected}
        placeholder={getTranslatedText(
          t,
          uischema?.placeholder,
          uischema?.placeholder || "Select"
        )}
        setSelectedValue={(val) => handleSelectValue(val)}
      />
    </div>
  ) : null;
};

CampaignNameSelectComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  required: PropTypes.bool,
  visible: PropTypes.bool,
  enabled: PropTypes.bool,
  data: PropTypes.array,
};

export const CampaignNameSelectControl = withJsonFormsMultiEnumProps(
  CampaignNameSelectComponent
);
